export default /localhost/.test(location.host)
    /*? "http://localhost:3000"*/
    ? "https://peeract-api.kopfhandundfuss.net"
    : "https://peeract-api.kopfhandundfuss.net"
